export const assessmentSummaryConstants = {

    // REQUEST BATCH 
    REQUEST_BATCH: 'REQUEST_BATCH',
    RECEIVE_BATCH: 'RECEIVE_BATCH',
    BATCH_ERROR: 'BATCH_ERROR',

    // GET ASSESSMENTS
    REQUEST_ASSESSMENT: 'REQUEST_ASSESSMENT',
    RECEIVE_ASSESSMENT: 'RECEIVE_ASSESSMENT',
    ASSESSMENT_ERROR: 'ASSESSMENT_ERROR',

    // GET ASSESSMENT REPORT
    REQUEST_ASSESSMENT_REPORT: 'REQUEST_ASSESSMENT_REPORT',
    RECEIVE_ASSESSMENT_REPORT: 'RECEIVE_ASSESSMENT_REPORT',
    ASSESSMENT_REPORT_ERROR: 'ASSESSMENT_REPORT_ERROR',




};



// WEBPACK FOOTER //
// ./src/_constants/assessmentSummary.constants.js